import axios from 'axios';
import BaseApi from './base';
import {
    LOCALES,
    SET_LOCALE
} from '@/constants/api';

export default class extends BaseApi {
    static get() {
        return axios.get(LOCALES);
    }

    static post(locale) {
        return axios.post(SET_LOCALE, this.stringify({
            locale
        }))
    }
}